import { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { confirmSubscription } from '../../../api/payment';
import { Link, useParams } from 'react-router-dom';
import SpinnerFullSection from '../../Other/SpinnerFullSection';

function PaymentSuccess() {
	const [confirmed, setConfirmed] = useState(false);
	const [error, setError] = useState(false);
	const {orgId, sessionId} = useParams();

	const queryClient = useQueryClient();
	const mutation = useMutation(confirmSubscription, {
		onSuccess: (data) => {
			// console.log(data);
			setConfirmed(true);
			setError(false);
			queryClient.invalidateQueries(["Subscription", orgId]);
			queryClient.invalidateQueries(['Organizations']);
		},
		onError: (error) => {
			// console.error(error)
			setError(true);
			setConfirmed(false);
		},
	});

	useEffect(()=>{
		if(sessionId && orgId) {
			mutation.mutate({orgId, sessionId});
		}
	}, [sessionId]);

	return (
		<Container className='mt-5' style={{maxWidth:'800px', position:'relative'}}>
			{mutation.isLoading && <SpinnerFullSection/>}

			{confirmed && (
				<div className='text-center  border border-success rounded p-4'>
					<h2>Subscription confirmed!</h2>
					<p>Thank you for working with us!</p>
					<p>Now you can access premium features on our platform.</p>
					<Link to={`/dashboard/orgs/${orgId}`}>
						<Button>Start your service</Button>
					</Link>
				</div>
			)}
			{error && (
				<div className='text-center border border-danger rounded p-4'>
					<h2>Failed to confirm subscription.</h2>
					<p>Please try again or <Link to={"/dashboard/support"}>contact us</Link> directly and we can get this sorted out.</p>
					<p>Thank you.</p>
				</div>)
			}
		</Container>
	)
};

export default PaymentSuccess;
